import React, { useEffect, useState } from 'react';
import PropTypes from 'prop-types';

import i18n from 'i18n-react';

import { APIHandler, ContentHeader, DataHandler, Progress, StorageHandler, SweetAlert, TrainingGrid } from 'config/C4';
import { storageKeys } from 'config/settings';

const getUserInfo = async (callback) => {
  const { response: user = null } = await StorageHandler.load(storageKeys.user);
  if (user) {
    const { email, first_name: firstName, last_name: lastName } = user;
    const response =
      (await StorageHandler.load(storageKeys.progress)) ||
      (await APIHandler.getUserProgress(DataHandler.matchAppId(), email));

    StorageHandler.save(storageKeys.progress, response);
    const {
      data: [{ chapters }],
    } = response || { data: [{ chapters: [] }] };

    const totalPages = chapters.map(({ total_pages: t }) => t).reduce((t, n) => t + n);
    const totalProgress = chapters.map(({ progress }) => progress).reduce((t, n) => t + n);
    const percentage = Math.min(100, Math.floor((totalProgress / totalPages) * 100));

    return callback({ totalProgress: percentage, firstName, lastName });
  }
  return callback({ totalProgress: 0, firstName: null, lastName: null });
};

const ViewDiploma = ({ diploma = null }) => {
  if (diploma !== 100) return null;

  const hasViewedDiploma = localStorage.getItem('hasViewedDiploma');
  if (hasViewedDiploma) return null;

  localStorage.setItem('hasViewedDiploma', true);
  setTimeout(() => {
    document.getElementById('showDiplomaButton').click();
  }, 2000);

  return null;
};

const getDate = () => {
  const [date, time] = new Date(Date.now()).toLocaleString('ja-JP').split(' ');
  return `${date
    .split('/')
    .map((n) => `0${n}`.slice(-2))
    .join('-')} ${time}`;
};

const graduateUser = async () => {
  const obj = await StorageHandler.load(storageKeys.user);
  const { response: user } = obj;
  const { training_graduated: graduated = undefined, email } = user;
  if (graduated === null) {
    const date = getDate();
    const updateData = { sales_companion_registered: date, training_started: date, training_graduated: date };

    const res = await APIHandler.updateUser(
      DataHandler.matchAppId(),
      email,
      Object.keys(updateData).map((key) => ({ param: key, val: updateData[key] })),
    );

    if (res) {
      Object.keys(updateData).forEach((key) => {
        obj.response[key] = updateData[key];
      });
      StorageHandler.save(storageKeys.user, obj);
    }
  }
};

const closePopup = (callback) => {
  localStorage.setItem('viewedTrainingPopup', true);
  callback(false);
};

const TrainingView = () => {
  const [{ totalProgress }, setUserInfo] = useState({});
  const [popup, setPopup] = useState(false);

  useEffect(() => {
    getUserInfo(setUserInfo);
  }, []);

  useEffect(() => {
    if (totalProgress === 100) graduateUser();
  }, [totalProgress]);

  const close = () => closePopup(setPopup);

  const trainingSwal = {
    title: i18n.translate('trainingScreens.trainingPopupTitle'),
    text: i18n.translate('trainingScreens.trainingPopupText'),
    show: { popup },
    onConfirm: { close },
    onCancel: { close },
    onEscapeKey: { close },
    onOutsideClick: { close },
  };

  return (
    <div className="contentContainer trainingView">
      <ContentHeader
        header={i18n.translate('contentHeaders.train')}
        subtitle={i18n.translate('pageDescriptions.train')}
      >
        <SweetAlert trigger={popup} {...trainingSwal} />
        <div className="container__Progress">
          <div className="container__progressBar">
            <h6 className="progressText">
              {i18n.translate('trainingScreens.percentageComplete', { number: totalProgress })}
            </h6>
            <Progress id="progress" value={totalProgress} />
          </div>
        </div>
      </ContentHeader>

      <TrainingGrid />
    </div>
  );
};

export default TrainingView;

ViewDiploma.propTypes = {
  diploma: PropTypes.number,
};
